import React, { FC } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

const CustomSkeleton: FC<SkeletonProps> = ({
    ...skeletonProps
}) => {
    return (
        <Skeleton
            height={25}
            {...skeletonProps}
        />
    );
};

export default CustomSkeleton;
